import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import { passwordRegex } from "../../constants/constants";

import Error from "../../components/error";
import SuccessMsg from "../../components/successMsg";
import Button from "../../components/button";
import ICInput from "../../components/form/input";

const PasswordForm = props => {
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmNewPassword: ""
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .required("Please enter New Password")
        .min(8, "Password must be of minimum length 8")
        .matches(
          passwordRegex,
          "Password should be at least 8 and maximum 25 characters long and should contain one number, one special character, one uppercase and one lowercase."
        ),
      confirmNewPassword: Yup.string()
        .required("Please enter Confirm Password")
        .oneOf([Yup.ref("newPassword")], "Both Passwords should match")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form
      className="d-flex flex-column align-items-center"
      onSubmit={formik.handleSubmit}
    >
      <ICInput
        name="newPassword"
        type="password"
        label="New Password *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.newPassword}
        error={
          formik.touched.newPassword && formik.errors.newPassword ? true : false
        }
        helperText={
          formik.touched.newPassword && formik.errors.newPassword
            ? formik.errors.newPassword
            : ""
        }
      />
      <br />
      <ICInput
        name="confirmNewPassword"
        type="password"
        label="Confirm Password *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.confirmNewPassword}
        error={
          formik.touched.confirmNewPassword && formik.errors.confirmNewPassword
            ? true
            : false
        }
        helperText={
          formik.touched.confirmNewPassword && formik.errors.confirmNewPassword
            ? formik.errors.confirmNewPassword
            : ""
        }
      />
      <br />
      <Button title="Submit" type="submit" disabled={props.isProcessing} />
      <br />
      <Error>{props.serverErrorMsg}</Error>
      <SuccessMsg>{props.successMsg}</SuccessMsg>
    </form>
  );
};

export default PasswordForm;

PasswordForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: "",
  isProcessing: false
};

PasswordForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string,
  isProcessing: PropTypes.bool
};
